// extracted by mini-css-extract-plugin
export default {"badge":"EmailDefaultBadge_badge__EXrr5"};